import { UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { QueryKeys } from '../../enums/queryKeys';
import { MutationKeys } from '../../enums/mutationKeys';
import { NotificationTypes } from '../../enums/notificationTypes';
import { DashboardServicesResponse, DashboardSettings } from '../../models/dashboard.model';
import { fetchDashboardServices, fetchDashboardSettings, saveDashboardSettings, notifyHomeService, getAxiosErrorMessage } from './homeServiceUtils';

const useHomeService = () => {
  // Keyed on the CES Admin's selected client so a client switch never reads the previous client's services.
  const getDashboardServices = (clientId?: number): UseQueryOptions<DashboardServicesResponse, Error> => ({
    queryKey: [QueryKeys.GET_DASHBOARD_SERVICES, clientId],
    queryFn: fetchDashboardServices,
  });

  const getDashboardSettings = (): UseQueryOptions<DashboardSettings, Error> => ({
    queryKey: [QueryKeys.GET_DASHBOARD_SETTINGS],
    queryFn: fetchDashboardSettings,
  });

  const updateDashboardSettings = (): UseMutationOptions<{ message: string }, Error, DashboardSettings> => ({
    mutationKey: [MutationKeys.UPDATE_DASHBOARD_SETTINGS],
    mutationFn: saveDashboardSettings,
    onSuccess: (data) => notifyHomeService(NotificationTypes.SUCCESS, data.message),
    onError: (error) => notifyHomeService(NotificationTypes.ERROR, getAxiosErrorMessage(error)),
  });

  return {
    getDashboardServices,
    getDashboardSettings,
    updateDashboardSettings,
  };
};

export default useHomeService;
